import React from 'react';
import cn from 'classnames';
import styles from './RectangleSkeleton.module.scss';
const RectangleSkeleton = ({ className, height, width, shouldUseShimmerAnimation = true, style, }) => {
    const sizeStyle = Object.assign(Object.assign({ height }, (width && { width })), style);
    return (React.createElement("div", { className: cn(styles.container, className, shouldUseShimmerAnimation && styles.shimmerAnimation), style: sizeStyle }));
};
export default RectangleSkeleton;
//# sourceMappingURL=RectangleSkeleton.js.map